<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-alert(
            dense
            text
            type="info"
            class="py-4"
          )
            | My Permit menampilkan permit yang Anda buat. 
            | Jika ingin melakukan approval, silakan buka My Approval List atau 
            router-link(
              to="/my-approval-list" 
              class="text-decoration-none"
            ) klik di sini
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
              ExportLaporan(:title="title")
            PermitModal(imId="button")
          v-divider
          PermitList(
            :title='title'
            :dialogType='dialogType'
            :ip='getIp()'
            :fromPage="'myPermit'"
          )
</template>

<script>
import * as config from "../config/index.json";
import PermitModal from "@/components/PermitModal.vue";
import PermitList from "@/components/PermitList.vue";
import { mapState } from "vuex";
import helper from "../helper/index.js";
import ExportLaporan from "@/components/modal/ExportLaporan.vue";
export default {
  name: "MyPermit",
  components: {
    PermitModal,
    PermitList,
    ExportLaporan
  },
  data () {
    return {
      config: config.default,
      title: 'My Permit',
      dialogType: 'creator',
      ip: {
        headers: [
          {
            text: 'Nomor',
            align: 'start',
            sortable: false,
            value: 'ipNo',
            width: '160px'
          },
          { text: 'Judul Pekerjaan', value: 'ipJudulPekerjaan',width: '210px' },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Perusahaan', value: 'ipPerusahaan' },
          { text: 'Form', value: 'ipFormShortName' },
          { text: 'Nama Pemegang Izin', value: 'ipPemegangIzin.name',width: '170px' },
          { 
            text: 'Status', 
            value: 'ipStatusLabel', 
            align: 'center', 
            width: '120px',
            sortable: false,
          },
          { 
            text: 'Action', 
            value: 'actions',
            sortable: false, 
          },
          { text: '', value: 'data-table-expand' }
        ],
        items: []
      }, 
    }
  },
  mounted () {
    this.$store.dispatch("fetchNewfetchMyPermit")
  },
  computed: {
    ...mapState(["myPermit","API_URL","dataUsers"]),
  },
  methods: {

    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate,
    getIp() {
      this.ip.items = this.$store.state.newMyPermit.data;
      this.ip.jumlah = this.$store.state.newMyPermit.jumlah;

      if(this.ip.items){
        for (let i = 0; i < this.ip.items.length; i++) {
          this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
          this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
          this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
          this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
        }
      }

      return this.ip;
    },
  },
};
</script>
